import React from 'react';

type Props = {
  divClass?: string,
  spanClass?: string,
  dataId?: string,
  errorMessage: string,
};

function InputError(props: Props) {
  const { divClass, spanClass, dataId, errorMessage } = props;

  return (
    <div className={divClass}>
      <span className={spanClass} data-automation-id={dataId && dataId}>
        {errorMessage}
      </span>
    </div>
  );
}

InputError.defaultProps = {
  divClass: 'form-input--error form-input',
  spanClass: 'form-input-error__message',
  dataId: null,
};

export default InputError;
